import React, { useEffect, useState } from 'react';
import { Search, Loader2, Check } from 'lucide-react';
import { api } from '../../context/AuthContext';

// Einheitliche Auswahl „Mandant → Akte“ für alle Bereiche
export const MandantAktePicker = ({ value, onChange, initialQuery = '', testId = 'mandant-akte-picker' }) => {
  const [q, setQ] = useState(initialQuery);
  const [hits, setHits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [akten, setAkten] = useState([]);
  const mnr = value?.mandanten_nr;

  useEffect(() => {
    const id = setTimeout(() => {
      setLoading(true);
      api.get('/register/mandanten', { params: { q } }).then((r) => setHits(r.data.items || [])).finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(id);
  }, [q]);
  useEffect(() => {
    if (!mnr) { setAkten([]); return; }
    api.get(`/register/mandanten/${mnr}/akten`).then((r) => setAkten((r.data.items || []).filter((a) => !a.archived || a.case_id === value?.case_id)));
  }, [mnr, value?.case_id]);

  return (
    <div className="space-y-2" data-testid={testId}>
      <div className="flex items-center gap-2 border border-gray-200 px-2.5 py-1.5 bg-white focus-within:border-[#b8893d]">
        <Search className="w-3.5 h-3.5 text-[#7a8a99]" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Mandantennr., Name, E-Mail oder Aktenzeichen" data-testid={`${testId}-search`}
          className="flex-1 text-sm focus:outline-none" />
        {loading && <Loader2 className="w-3.5 h-3.5 animate-spin text-[#7a8a99]" />}
      </div>
      <ul className="max-h-44 overflow-y-auto border border-gray-100 divide-y divide-gray-50">
        {hits.length === 0 && !loading && <li className="px-3 py-3 text-xs text-[#7a8a99] text-center">Kein Mandant gefunden.</li>}
        {hits.map((h) => (
          <li key={h.mandanten_nr}>
            <button type="button" onClick={() => onChange({ mandanten_nr: h.mandanten_nr, case_id: null, name: h.name, email: h.email, akte: null })} data-testid={`${testId}-mandant-${h.mandanten_nr}`}
              className={`w-full flex items-center gap-2 px-3 py-1.5 text-left text-xs transition-colors ${mnr === h.mandanten_nr ? 'bg-[#1B3A5C] text-white' : 'hover:bg-[#f5f8fa] text-[#1B3A5C]'}`}>
              <span className="font-mono w-14 flex-shrink-0">M-{h.mandanten_nr}</span>
              <span className="flex-1 truncate">{h.name}</span>
              <span className="opacity-60 flex-shrink-0">{h.akten} Akte{h.akten === 1 ? '' : 'n'}</span>
              {mnr === h.mandanten_nr && <Check className="w-3.5 h-3.5" />}
            </button>
          </li>
        ))}
      </ul>
      {mnr && (
        <div>
          <p className="text-[10px] tracking-[0.2em] text-[#7a8a99] mb-1">AKTE (OPTIONAL)</p>
          <div className="flex flex-wrap gap-1.5">
            {[{ case_id: null, aktenzeichen: null, rechtsgebiet: 'Ohne Akte · Allgemein' }, ...akten].map((a) => (
              <button key={a.case_id || 'none'} type="button" onClick={() => onChange({ ...value, case_id: a.case_id, akte: a.case_id ? a : null })} data-testid={`${testId}-akte-${a.case_id || 'none'}`}
                className={`px-2.5 py-1 text-[11px] rounded-full border transition-colors ${(value?.case_id || null) === a.case_id ? 'bg-[#b8893d] border-[#b8893d] text-white' : 'border-gray-200 text-[#1B3A5C] hover:border-[#b8893d]'}`}>
                {a.aktenzeichen ? <span className="font-mono">AZ {a.aktenzeichen}</span> : a.rechtsgebiet}
                {a.aktenzeichen && <span className="opacity-70"> · {a.rechtsgebiet}</span>}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MandantAktePicker;
